module.exports = __webpack_public_path__ + "img/feature-6.4325fd0.png";